import { render, staticRenderFns } from "./cg-event-infos.vue?vue&type=template&id=09df6e4f&scoped=true"
import script from "./cg-event-infos.vue?vue&type=script&lang=js"
export * from "./cg-event-infos.vue?vue&type=script&lang=js"
import style0 from "./cg-event-infos.vue?vue&type=style&index=0&id=09df6e4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09df6e4f",
  null
  
)

export default component.exports